import API from '@api/api'
import { IMAGE_TYPE } from "@utils/CONST"
import Utils from '@utils/utils'
import eventBus from '@utils/eventBus';
import axios from 'axios';
import { message } from 'antd';

// 分割
export const maskPrediction = (filename, imageType, stopCondition) => {
    let APIobj = API.maskPrediction
    if (imageType == IMAGE_TYPE.MODEL) APIobj = API.maskPrediction
    if (imageType == IMAGE_TYPE.CLOTHES) APIobj = API.maskPredictionAicloth // Vision tryon
    if (imageType == IMAGE_TYPE.DRESSFORM) APIobj = API.maskPredictionAidressform
    if (imageType == IMAGE_TYPE.COMMODITY) APIobj = API.maskPredictionGoods
    let mask_style = 4
    if (imageType == IMAGE_TYPE.CLOTHES) mask_style = 3
    return APIobj({
        image: filename,
        mask_style: mask_style,
    }).then(res => {
        if (res.code != 0) throw new Error(res.message)
        return getMaskResult(res.data, imageType, stopCondition)
    }).catch((err) => {
        console.log(err)
    })
}
// 获取分割结果
export const getMaskResult = (id, imageType, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            let url = API.maskPredictionUrl + id
            if (imageType == IMAGE_TYPE.MODEL) url = API.maskPredictionUrl + id
            if (imageType == IMAGE_TYPE.CLOTHES) url = API.maskPredictionAiclothUrl + id // Vision tryon
            if (imageType == IMAGE_TYPE.DRESSFORM) url = API.maskPredictionAidressformUrl + id
            if (imageType == IMAGE_TYPE.COMMODITY) url = API.maskPredictionUrlGoods + id
            axios.post(url, {}, {
                headers: {
                    'Content-type' : 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then(async (res) => {
                if((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    resolve({
                        output: res.data.data.output,
                        input: res.data.data.input,
                        id
                    })
                } else if(res.data.code == 0 && res.data.data.status == 'failed') {
                    const error = Utils.parseErrorCode(`[${res.data.data.errcode}]`)
                    eventBus.emit('notification', '分割失败', error.message, 'error', error.code)
                    reject()
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 400)
                }
            })
        }
        loopFunc()
    })
}

// 获取第一次的npy文件等，交互式分割第一步获取embedding
export const maskDispose = (output, stopCondition) => {
    return API.aiinteractivePrediction({
        img_path: output[0],
        mask_path: output[4],
        points_json: JSON.stringify([{x: 0, y: 0, label: 1}]),
        img_embedding_path: '',
        logits_path: ''
    }).then((res) => {
        if (res.code != 0) throw new Error(res.message)
        return getMaskDisposeResult(res.data, stopCondition)
    }).catch((err) => {
        if (!err) return
        console.log(err)
        message.error(err.message)
    })
}

// 获取embedding结果
export const getMaskDisposeResult = (id, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            axios.post(API.aiinteractivePredictionUrl + id,  {}, {
                headers: {
                    'Content-type' : 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then(res => {
                if((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    resolve({
                        id,
                        npy: res.data.data.output[0]
                    })
                } else if(res.data.code == 0 && res.data.data.status == 'failed') {
                    const error = Utils.parseErrorCode(`[${res.data.data.errcode}]`)
                    eventBus.emit('notification', '检测失败', error.message, 'error', error.code)
                    reject()
                } else {
                    if (stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 400)
                }
            })
        }
        loopFunc()
    })
}

// 多语义分割
export const multiSemantic = (url, stopCondition) => {
    return API.multiSemanticPrediction({
        image_path: url
    }).then(res => {
        if (res.code != 0) throw new Error(res.message)
        return getMultiSemanticResult(res.data, stopCondition)
    }).catch((err) => {
        if (!err) return
        console.log(err)
        message.error(err.message)
    })
}

export const getMultiSemanticResult = (id, stopCondition) => {
    return new Promise((resolve, reject) => {
        const loopFunc = () => {
            let url = API.multiSemanticPredictionUrl + id
            axios.post(url, {}, {
                headers: {
                    'Content-type' : 'application/json',
                    'Ps-Auth-Token': localStorage.getItem('token')
                }
            }).then(async (res) => {
                if((res.data.code == 0 && res.data.data.status == 'succeeded')) {
                    resolve({
                        id,
                        output: res.data.data.output,
                    })
                } else if(res.data.code == 0 && res.data.data.status == 'failed') {
                    const error = Utils.parseErrorCode(`[${res.data.data.errcode}]`)
                    eventBus.emit('notification', '分割失败', error.message, 'error', error.code)
                    reject()
                } else {
                    if (stopCondition && stopCondition()) return resolve()
                    setTimeout(() => {
                        loopFunc()
                    }, 400)
                }
            })
        }
        loopFunc()
    })
}

export default {
    maskDispose,
    maskPrediction,
    multiSemantic,
}